
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 184 121","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M47.796 112.161a3.874 3.874 0 01-2.867-1.258L1.026 63.162a3.893 3.893 0 010-5.266l43.903-47.74a3.895 3.895 0 016.756 2.465 3.886 3.886 0 01-1.022 2.796L9.175 60.529l41.488 45.115a3.888 3.888 0 01-2.867 6.517zM135.962 112.162a3.892 3.892 0 01-3.839-4.525 3.882 3.882 0 01.972-1.993l41.488-45.114-41.488-45.115a3.886 3.886 0 013.044-6.468 3.894 3.894 0 012.69 1.209l43.903 47.742a3.892 3.892 0 010 5.265l-43.903 47.74a3.872 3.872 0 01-2.867 1.259zM78.036 121a3.893 3.893 0 01-3.789-4.811L101.94 3.024a3.89 3.89 0 014.689-2.787 3.892 3.892 0 012.873 4.633L81.815 118.035A3.896 3.896 0 0178.036 121z","fill":"#fff"}})])
          )
        }
      }
    